import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function PestService(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "PestService", sx, viewBox, children: [
    /* @__PURE__ */ jsx("path", { d: "M5.977 10.311h36.046v31.315H5.977V10.31Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.7 29.182h-7.14a.752.752 0 0 1-.751-.752.752.752 0 0 1 .752-.752h7.138v1.504Zm0-2.502c-.069 0-1.682-.01-3.378-.799-1.47-.685-3.253-2.081-3.79-4.894a.754.754 0 0 1 .669-.892.747.747 0 0 1 .807.597c.338 1.784 1.327 3.07 2.95 3.825a7.28 7.28 0 0 0 2.741.659v1.504Zm-6.498 10.085H14.2a.754.754 0 0 1-.668-.892c.536-2.813 2.32-4.21 3.79-4.894 1.695-.79 3.308-.8 3.376-.8l.002 1.505c-.206.001-4.846.078-5.691 4.477a.75.75 0 0 1-.808.604Zm13.41-7.583h7.14a.751.751 0 0 0 .751-.752.752.752 0 0 0-.752-.752h-7.139v1.504Zm0-2.502c.068 0 1.682-.01 3.378-.799 1.469-.685 3.253-2.081 3.789-4.894a.754.754 0 0 0-.668-.892.747.747 0 0 0-.807.597c-.338 1.785-1.328 3.07-2.95 3.825a7.282 7.282 0 0 1-2.742.659v1.504Zm6.498 10.085h.001a.754.754 0 0 0 .668-.892c-.536-2.813-2.32-4.21-3.79-4.894-1.695-.79-3.309-.8-3.377-.8l-.002 1.505c.207.001 4.847.078 5.692 4.478a.75.75 0 0 0 .808.603Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M28.035 22.356h-2.26a.878.878 0 0 0-.879.878v2.926c0 .405-.312.759-.717.77a.741.741 0 0 1-.763-.74v-2.956a.878.878 0 0 0-.878-.878h-2.261a1.923 1.923 0 0 0-1.924 1.924v6.18a5.802 5.802 0 1 0 11.605 0v-6.18a1.923 1.923 0 0 0-1.923-1.924Zm-.105-6.633a.637.637 0 0 0-.895-.091l-1.15.937a3.406 3.406 0 0 0-1.73-.469c-.63 0-1.22.171-1.728.469l-1.15-.937a.635.635 0 1 0-.804.987l.984.8a3.405 3.405 0 0 0-.723 2.103v1.2a.491.491 0 0 0 .49.49h5.863a.49.49 0 0 0 .49-.49v-1.2a3.4 3.4 0 0 0-.722-2.102l.984-.801a.636.636 0 0 0 .091-.896Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M28.162 8.665H14.283V4.408H26.67c.824 0 1.493.668 1.493 1.492v2.765Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M23.195 8.665H9.316V4.408h12.055c1.007 0 1.824.816 1.824 1.823v2.434Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M40.793 11.464v29.329H7.207V11.464h33.586Zm2.8-2.799H4.407v34.927h39.184V8.665ZM18.285 6.387a1.98 1.98 0 0 0-1.98-1.98H6.389a1.98 1.98 0 0 0-1.98 1.98v2.278h13.878V6.387Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.097 5.972h-4.045a.886.886 0 1 0 0 1.772h4.045a.886.886 0 0 0 0-1.772Z",
        fill: theme.vars.palette.secondary.main
      }
    )
  ] });
}
PestService.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "PestService"
};
validateTidalLicense();
export {
  PestService
};
//# sourceMappingURL=PestService.js.map
